export const PREDICTION_TEAM_SELECTED_EVENT = 'prediction:team-selected';
export const PREDICTION_CHART_REFRESH_EVENT = 'prediction:chart-refresh';
export const PREDICTION_TEAM_ID_ATTRIBUTE = 'data-selected-market-event-team-id';

const normalizeTeamId = value => value === null || value === undefined || value === ''
    ? null
    : String(value);

export const publishPredictionChartTeamSelection = (canvas, marketEventTeamId) => {
    const normalizedId = normalizeTeamId(marketEventTeamId);
    if (!canvas || normalizedId === null) return false;

    canvas.setAttribute(PREDICTION_TEAM_ID_ATTRIBUTE, normalizedId);
    canvas.dispatchEvent(new CustomEvent(PREDICTION_TEAM_SELECTED_EVENT, {
        detail: {marketEventTeamId: normalizedId}
    }));
    return true;
};

export const findPredictionDatasetIndex = (datasets, marketEventTeamId) => {
    const normalizedId = normalizeTeamId(marketEventTeamId);
    if (normalizedId === null) return null;

    const index = datasets.findIndex(dataset =>
        normalizeTeamId(dataset.marketEventTeamId) === normalizedId
    );
    return index >= 0 ? index : null;
};

export const bindPredictionChartTeamSelection = (chart, canvas) => {
    const applySelection = marketEventTeamId => {
        const nextIndex = findPredictionDatasetIndex(
            chart.data.datasets,
            marketEventTeamId
        );
        if (chart.$predictionSelectedDatasetIndex === nextIndex) return;

        chart.$predictionSelectedDatasetIndex = nextIndex;
        chart.update('none');
    };
    const onSelection = event => applySelection(event.detail?.marketEventTeamId);

    applySelection(canvas.getAttribute(PREDICTION_TEAM_ID_ATTRIBUTE));
    canvas.addEventListener(PREDICTION_TEAM_SELECTED_EVENT, onSelection);

    return () => canvas.removeEventListener(PREDICTION_TEAM_SELECTED_EVENT, onSelection);
};
